export default __webpack_public_path__ + "static/media/u_wdt_c_1.6a8ce623.mp3";